import { ENDPOINTS, HOSTS } from "@/constants";
import {
  ADD_INTERVENTION,
  ADD_INTERVENTION_FAILURE,
  ADD_INTERVENTION_SUCCESS,
  DELETE_INTERVENTION,
  DELETE_INTERVENTION_FAILURE,
  DELETE_INTERVENTION_SUCCESS,
  LOAD_INTERVENTION,
  LOAD_INTERVENTION_FAILURE,
  LOAD_INTERVENTION_SUCCESS,
  LOAD_INTERVENTIONS,
  LOAD_INTERVENTIONS_ALL_SUCCESS,
  LOAD_INTERVENTIONS_FAILURE,
  LOAD_INTERVENTIONS_SUCCESS,
  UPDATE_INTERVENTION,
  UPDATE_INTERVENTION_FAILURE,
  UPDATE_INTERVENTION_SUCCESS,
} from "./mutations";
import type { ActionTree } from "vuex";
import type { RootState } from "@/types";
import { type AxiosResponse, httpClient } from "@/services/httpClient";
import type { Intervention } from "@/types/bexSupport";
import type { InterventionState } from "@/types/store";

export const actions: ActionTree<InterventionState, RootState> = {
  fetchInterventions({ commit }, params: any) {
    commit(LOAD_INTERVENTIONS);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.INTERVENTIONS}`, { params }).then(
      (response: AxiosResponse<Intervention[]>) => {
        commit(LOAD_INTERVENTIONS_SUCCESS, response);
      },
      (error) => {
        commit(LOAD_INTERVENTIONS_FAILURE, error.message);
      },
    );
  },
  fetchAllInterventions({ commit }, { params, idCompleted }) {
    commit(LOAD_INTERVENTIONS);

    const baseUrl = `${HOSTS.AWS}/${ENDPOINTS.INTERVENTIONS}`;

    const requestDefault = httpClient.get(baseUrl, { params });
    const requestCompleted = httpClient.get(baseUrl, {
      params: {
        ...params,
        interventionStatus: `${idCompleted}`,
      },
    });

    Promise.all([requestDefault as any, requestCompleted as any])
      .then(([defaultRes, completedRes]) => {
        commit(LOAD_INTERVENTIONS_ALL_SUCCESS, {
          data: defaultRes.data,
          total_count: defaultRes.total_count,
          data_completed: completedRes.data,
          count_completed: completedRes.total_count,
        });
      })
      .catch((error) => {
        commit(LOAD_INTERVENTIONS_FAILURE, error.message);
      });
  },
  addIntervention({ commit }, intervention: any) {
    commit(ADD_INTERVENTION);
    return httpClient
      .post(`${HOSTS.AWS}/${ENDPOINTS.INTERVENTIONS}`, {
        ...intervention,
      })
      .then(
        (response: AxiosResponse<any>) => {
          commit(ADD_INTERVENTION_SUCCESS, response.data);
          return response.data;
        },
        (error) => {
          commit(ADD_INTERVENTION_FAILURE, error.message);
        },
      );
  },
  updateIntervention({ commit }, intervention: any) {
    commit(UPDATE_INTERVENTION);
    return httpClient
      .put(
        `${HOSTS.AWS}/${ENDPOINTS.INTERVENTIONS}/${intervention.id}`,
        intervention,
      )
      .then(
        (response: AxiosResponse<any>) => {
          commit(UPDATE_INTERVENTION_SUCCESS, response.data);
          return response.data;
        },
        (error) => {
          commit(UPDATE_INTERVENTION_FAILURE, error.message);
        },
      );
  },

  // LOAD_EVENTS
  fetchIntervention({ commit }, id: any) {
    commit(LOAD_INTERVENTION);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.INTERVENTIONS}/${id}`).then(
      (response: AxiosResponse<any>) => {
        commit(LOAD_INTERVENTION_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_INTERVENTION_FAILURE, error.message);
      },
    );
  },

  deleteTicket({ commit }, ticketId: any) {
    commit(DELETE_INTERVENTION);
    httpClient
      .delete(`${HOSTS.AWS}/${ENDPOINTS.INTERVENTIONS}/${ticketId}`)
      .then(
        () => {
          commit(DELETE_INTERVENTION_SUCCESS, ticketId);
        },
        (error) => {
          commit(DELETE_INTERVENTION_FAILURE, error.message);
        },
      );
  },
};
